<template>
      <TheFooter>
        <div class="animated fadeIn">
          <!--footer-->
          <a href="https://www.tryonics.com">Fairfirst Insurance</a>
          <span class="ml-1">&copy; 2020 All Rights Reserved.</span>
        </div>
        <div class="ml-auto animated fadeIn">
          <span class="mr-1">Powered by</span>
          <a href="https://www.tryonics.com">Tryonics</a>
        </div>
      </TheFooter>
</template>
<script>
import { Footer as TheFooter } from '@coreui/vue'
export default {
  name: 'DefaultFooter',
  components: {
    TheFooter
  },
}
</script>
